import { Asset, MetadataFieldType } from '@/api/generatedApi';

export enum WizardStep {
  FILE_UPLOAD = 'file_upload',
  DATA_PREVIEW = 'data_preview',
  FIELD_TYPES = 'field_types',
  ASSET_MATCHING = 'asset_matching',
  CONFIRMATION = 'confirmation',
  PROCESSING = 'processing',
  RESULTS = 'results',
}

export interface ParsedMetadataRow {
  assetName: string;
  assetId?: string;
  metadata: Record<string, string>;
  rowIndex: number;
}

export interface AssetMatch {
  assetName: string;
  assetId?: string;
  searchResults: Asset[];
  selectedAsset?: Asset;
  status: 'pending' | 'matched' | 'multiple_matches' | 'no_match' | 'error' | 'asset_id_provided';
}

export interface MetadataFieldDefinition {
  name: string;
  type: MetadataFieldType;
  isNew: boolean;
}

export interface BulkUploadData {
  file: File;
  parsedData: ParsedMetadataRow[];
  metadataFields: string[];
  metadataFieldDefinitions: MetadataFieldDefinition[];
  assetMatches: AssetMatch[];
  duplicateWarnings?: DuplicateAssetWarning[];
  duplicateMetadataColumnWarnings?: DuplicateMetadataColumnWarning[];
  results?: BulkUploadResults;
}

export interface DuplicateAssetWarning {
  assetName: string;
  firstRowIndex: number;
  duplicateRowIndexes: number[];
}

export interface DuplicateMetadataColumnWarning {
  fieldName: string;
  firstColumnIndex: number;
  duplicateColumnIndexes: number[];
}

export interface UpdateResult {
  assetName: string;
  assetId: string;
  status: 'pending' | 'processing' | 'success' | 'error';
  updatedFields: Record<string, string>;
  errorMessage?: string;
}

export interface BulkUploadResults {
  totalProcessed: number;
  successful: UpdateResult[];
  failed: UpdateResult[];
  skipped: string[];
}
